import { Link } from 'react-router-dom';
import { Article, getCategoryById } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
  variant?: 'default' | 'featured' | 'compact';
}

export default function ArticleCard({ article, variant = 'default' }: ArticleCardProps) {
  const category = getCategoryById(article.category);

  if (variant === 'featured') {
    return (
      <Link
        to={`/article/${article.slug}`}
        className="group block relative rounded-lg overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-500/30 transition-all duration-300"
      >
        <div className="aspect-[16/9] overflow-hidden">
          <img
            src={article.image}
            alt={article.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            title={`${article.title} - 夜勤病栋深度解析`}
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-background-50/95 via-background-50/40 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-5">
          {category && (
            <span className="inline-block px-2.5 py-0.5 rounded-full text-xs font-medium bg-primary-500/20 text-primary-400 mb-2 whitespace-nowrap">
              {category.name}
            </span>
          )}
          <h3 className="font-heading text-lg font-bold text-foreground-100 group-hover:text-primary-300 transition-colors line-clamp-2 mb-2">
            {article.title}
          </h3>
          <p className="text-sm text-foreground-400 line-clamp-2">{article.excerpt}</p>
          <div className="flex items-center gap-3 mt-3 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line"></i>
              {article.date}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line"></i>
              {article.readTime} 分钟阅读
            </span>
          </div>
        </div>
      </Link>
    );
  }

  if (variant === 'compact') {
    return (
      <Link
        to={`/article/${article.slug}`}
        className="group flex gap-3 p-3 rounded-lg bg-background-100 border border-background-200/60 hover:border-primary-500/30 transition-all duration-300"
      >
        <div className="w-20 h-20 flex-shrink-0 rounded-md overflow-hidden">
          <img
            src={article.image}
            alt={article.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            title={`${article.title} - 夜勤病栋深度解析`}
          />
        </div>
        <div className="flex-1 min-w-0">
          {category && (
            <span className="inline-block px-2 py-0.5 rounded-full text-xs font-medium bg-primary-500/10 text-primary-400 mb-1 whitespace-nowrap">
              {category.name}
            </span>
          )}
          <h4 className="font-heading text-sm font-semibold text-foreground-200 group-hover:text-primary-300 transition-colors line-clamp-2">
            {article.title}
          </h4>
          <div className="flex items-center gap-2 mt-1 text-xs text-foreground-500">
            <span>{article.date}</span>
            <span>&middot;</span>
            <span>{article.readTime} 分钟</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block rounded-lg overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-500/30 transition-all duration-300"
    >
      <div className="aspect-[16/10] overflow-hidden">
        <img
          src={article.image}
          alt={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          title={`${article.title} - 夜勤病栋深度解析`}
        />
      </div>
      <div className="p-4">
        {category && (
          <span className="inline-block px-2.5 py-0.5 rounded-full text-xs font-medium bg-primary-500/10 text-primary-400 mb-2 whitespace-nowrap">
            {category.name}
          </span>
        )}
        <h3 className="font-heading text-base font-bold text-foreground-200 group-hover:text-primary-300 transition-colors line-clamp-2 mb-2">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-500 line-clamp-2 mb-3">{article.excerpt}</p>
        <div className="flex items-center gap-3 text-xs text-foreground-600">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {article.date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {article.readTime} 分钟阅读
          </span>
        </div>
      </div>
    </Link>
  );
}